import React, { useEffect } from 'react';
import { Section } from '@ydistri/ds';
import { useSelector } from 'react-redux';
import { ReduxState, useAppDispatch } from '../../../../../store';
import EntityListSteps from '../steps/EntityListSteps';
import { setVerificationTimeStamp } from '../../entityListAdministrationSlice';
import { EntityListTypeSupported } from '../../entityListsLib';
import { useCurrentEntityListState } from '../../hooks/useCurrentEntityListState';

interface EntityListEditModeSectionProps {
  entityListType: EntityListTypeSupported;
}

const EntityListEditModeSection: React.FC<EntityListEditModeSectionProps> = ({
  entityListType,
}) => {
  const dispatch = useAppDispatch();

  const selectedEntityList = useSelector(
    (state: ReduxState) => state.entityListsAdministration[entityListType].selectedEntityList,
  );

  const entityListState = useCurrentEntityListState(entityListType);
  const existingTimestamp = entityListState?.verificationTimeStamp;

  // Sync verificationTimeStamp from the API response only if we don't already
  // have one in Redux (e.g. set by initImport). Without this guard, navigating
  // away and back would overwrite the timestamp with a stale API value.
  useEffect(() => {
    if (!existingTimestamp) {
      dispatch(
        setVerificationTimeStamp({
          entityListType,
          data: selectedEntityList?.entityListImport?.verificationTimeStamp,
        }),
      );
    }
  }, [
    dispatch,
    entityListType,
    existingTimestamp,
    selectedEntityList?.entityListImport?.verificationTimeStamp,
  ]);

  if (selectedEntityList) {
    return (
      <Section header={selectedEntityList.name}>
        <EntityListSteps entityListType={entityListType} />
      </Section>
    );
  }
};

export default EntityListEditModeSection;
